import { schema } from 'normalizr'

import { userSchema } from './userNormalizers'

export const conversationSchema = new schema.Entity('conversations', {
  host: userSchema
})

export const conversationsSchema = [conversationSchema]
